module.exports = __webpack_public_path__ + "static/contact_widget_background-b2c7261a118f380f5ea3b2ca749455e5.png";